import Deferred from '@lts-web/utils/Deferred';

export const INIT_ABROAD_LOCATION = new Deferred();
export const INIT_DOMESTIC_LOCATION = new Deferred();
export const INIT_SEARCH_MODULES = new Deferred();
export const INIT_SUPPORTED_MODULES = new Deferred();
export const INIT_HOTELS_RESULTS = new Deferred();
export const INIT_FLIGHT_PRODUCTS = new Deferred();